import NoData from '@rio-cloud/rio-uikit/NoData';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { IdentificationType } from './types';

interface AssetIdentificationProps {
    assetIdentificationType?: IdentificationType | null;
    assetIdentification: string | null;
    showIdentificationType?: boolean;
}

const AssetIdentification = React.memo((props: AssetIdentificationProps) => {
    if (!props.assetIdentification?.trim()) {
        return <NoData text={<FormattedMessage id='intl-msg:common-message.noData' />} />;
    }

    return (
        <span>
            {props.assetIdentification}
            {props.showIdentificationType && props.assetIdentificationType && (
                <span>
                    {' '}
                    (
                    <FormattedMessage id={`intl-msg:asset.identification_type.${props.assetIdentificationType}`} />)
                </span>
            )}
        </span>
    );
});

export default AssetIdentification;
